/**
 * Determines if a dot should render as a small indicator.
 * A dot is small if it is outside the visible window or is at an edge
 * that indicates there are more slides in that direction.
 */
export function isSmallDot(index: number, startIndex: number, endIndex: number, totalSlides: number, isRtl = false) {
    let visualIndex = index;
    let visualStart = startIndex;
    let visualEnd = endIndex;

    if (isRtl) {
        visualIndex = totalSlides - 1 - index;
        visualStart = totalSlides - 1 - endIndex;
        visualEnd = totalSlides - 1 - startIndex;
    }

    // Dots completely outside the visible window are always small
    if (visualIndex < visualStart || visualIndex > visualEnd) return true;

    // Edge dots within the visible window are small only if not first/last
    return (
        (visualIndex === visualStart && visualIndex !== 0) ||
        (visualIndex === visualEnd && visualIndex !== totalSlides - 1)
    );
}
